/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$('.reveal').hover(
       function(){ $('#primary-product-image').addClass('hide');
       $('#secondary-product-image').removeClass('hide');
       },
       function(){ $('#primary-product-image').removeClass('hide'); 
       $('#secondary-product-image').addClass('hide'); 
       }
)